import AbstractNetworkStatus from '../all/AbstractNetworkStatus';

class WorkstationNetworkStatus extends AbstractNetworkStatus {
    constructor() {
        super();
    }
}

export default WorkstationNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/workstation/NetworkStatus.js